<template>
  <!-- 曲线弹窗 -->
  <el-dialog
      width="70%"
      top="16vh"
      :visible.sync="trqxzxdialogTableVisible"
      :modal-append-to-body="false"
      @close="closeDialog"
  >
    <div class="tz_cov" style="height: 35vw">
      <div
          style="width:100%;height:100%;margin:0 auto;position: absolute;top:0;left:0;z-index:444;background:rgba(0,0,0,0.4);"
          v-if="loadding">
      </div>
      <img src="@/assets/image/loading.gif" alt=""
           style="width:150px;height:150px;margin:0 auto;position: absolute;top:280px;left:45%;z-index: 555;"
           v-if="loadding">
      <img
          src="@/assets/image/guanbi.png"
          class="guanbiann"
          @click="closeDialog"
          alt=""
      />
      <div class="tz_cov_top">
        <span class="tz_cov_top_tit">{{ dialogTitle }}</span>
      </div>
      <div class="trwdcov jgdhei">
        <div class="trwdcov_top">
          <span class="trwdcov_top_tit">时间范围</span>
          <el-date-picker
              class="trwdcov_top_time"
              v-model="timetr"
              type="daterange"
              @blur="timetrpicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          >
          </el-date-picker>
          <span class="trwdcov_top_tit">展示方式</span>
          <el-radio-group v-model="radiotr" @change="agreeChange">
            <el-radio label="1">折线</el-radio>
            <el-radio label="2">表格</el-radio>
          </el-radio-group>
        </div>
        <el-table
            :data="formListVlaue"
            v-show="trzx"
            height="480"
            border
            style="margin-top: 1vw; background: none"
        >
          <el-table-column prop="date" label="时间"></el-table-column>
          <el-table-column prop="name" :label="'数值单位：' + unitValue">
          </el-table-column>
        </el-table>
        <div id="maintczxtc" v-show="!trzx" style="width: 100%; height: 500px"></div>
      </div>
      <img src="@/assets/image/kuang_zuoshang.png" class="in2con_zlf" alt="">
      <img src="@/assets/image/kuang_youshang.png" class="in2con_zys" alt="">
      <img src="@/assets/image/kuang_zuoxia.png" class="in2con_zzx" alt="">
      <img src="@/assets/image/kuang_youxia.png" class="in2con_zyx" alt="">
      <img src="@/assets/image/sanguang.png" class="tzsanguang" alt="">
      <img src="@/assets/image/sanguang.png" class="tzsanguangbt" alt="">
    </div>
  </el-dialog>
</template>

<script>

import {survItemSummary} from "@/api";

export default {
  props: {
    item: Object
  },
  components: {},
  data() {
    return {
      trqxzxdialogTableVisible: true,
      loadding: true,
      dialogTitle: '',
      radiotr: '1',
      timetr: [new Date(), new Date()],
      trzx: false,
      formListVlaue: [],
      unitValue: '',
      echartObj: null,
    }
  },
  mounted() {
    console.log('单曲线弹窗显示拉!', this.item)
    //stationCode: item.stationCode,
    // deployId: item.deployId,
    //     survItem: survItem
    this.deviceSummaryApi();
  },
  methods: {
    // 历史数据曲线弹窗
    deviceSummaryApi() {
      let obj = {
        stationCode: this.item.stationCode,
        deployId: this.item.deployId,
        survItem: this.item.survItem,
        endTime: this.endTime,
        startTime: this.startTime,
      }
      this.loadding = true
      survItemSummary(obj).then(res => {
        let that = this
        this.loadding = false
        if(res.result){
          this.dataListVlaue = res.result.dataList
          this.timeListVlaue = res.result.timeList
          this.formListVlaue = res.result.formList
          // this.limitStrValue = res.result.itemInfo.limitStr
          if (this.timeListVlaue) {
            this.unitValue = res.result.itemInfo.unit
            this.dialogTitle = res.result.itemInfo.description
            setTimeout(() => {
              that.$nextTick(() => {
                that.drawChartTc();
              })
            }, 200)
          }
        }
      })
    },
    drawChartTc() {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      if(this.echartObj){
        this.echartObj.clear()
      } else {
        this.echartObj = this.$echarts.init(document.getElementById("maintczxtc"));
      }
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#3c6ae1'
            }
          }
        },
        legend: {
          data: ['']
        },
        toolbox: {},
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [  // 渐变颜色
              {
                offset: 0,
                color: 'rgba(85,111,253,0.70)',
              },
              {
                offset: 1,
                color: 'rgba(85,111,253,0.20)',
              },
            ],
            global: false,
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.timeListVlaue.reverse(),
            textStyle: {
              color: "#fff",
            },
            axisLabel: {
              //x轴文字的配置
              show: true,
            },
          }
        ],
        yAxis: [
          {
            name: this.unitValue,
            type: 'value',
            textStyle: {
              color: "#fff",
            },
            axisLabel: {
              formatter: '{value}',
              //x轴文字的配置
              show: true,
            },
          }
        ],
        series: [
          {
            name: this.dialogTitle,
            animationDurationUpdate: 1000, // 更新动画时长为 1s
            animationEasingUpdate: 'quinticInOut', // 更新动画缓动效果为 'quinticInOut'
            type: 'line',
            stack: 'Total',
            smooth: true,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            lineStyle: {
              color: '#3c6ae1' // 设置线的颜色为红色
            },
            data: this.dataListVlaue.reverse(),
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.echartObj.setOption(option);
    },
    // 时间
    timetrpicker(data) {
      this.startTime = data.displayValue[0];
      this.endTime = data.displayValue[1];
      this.deviceSummaryApi()
    },
    agreeChange(val) {
      let that = this
      if (val == '1') {//折线
        this.trzx = false
      } else if (val == '2') {//表格
        this.trzx = true
      }
      // that.deviceSummaryApi();
    },
    closeDialog() {
      this.$emit('close')
    }

  }
}
</script>

<style scoped>

.tz_cov {
  width: 100%;
  height: 30vw;
  margin: 0 auto;
  /* margin-top: 4vw; */
  border: 1px solid #0169d0;
  position: relative;
  background: rgba(16, 45, 80, 1);
  box-shadow: inset 0px 0px 16px 0px rgba(0, 145, 255, 1);
}

.tz_cov_top {
  width: 40%;
  height: 3vw;
  margin: 0 auto;
  background: url(../assets/image/tz_tltle_bg.png) no-repeat;
  background-size: cover;
  text-align: center;
  line-height: 3vw;
  margin-bottom: 2vw;
}

.tz_cov_top_tit {
  font-size: 1vw;
  color: #fff;
  text-shadow: 0px 2px 0px rgba(4, 49, 52, 0.55);
  font-family: douyuFont;
}

</style>